export type ItemsTableMessages = {
  titleColumn: string;
  variationColumn: string;
  quantityColumn: string;
  mainPriceColumn: string;
  promoPriceColumn: string;
  startPromoPriceColumn: string;
  endPromoPriceColumn: string;
  skuCodeColumn: string;
  netUnitPriceColumn: string;
  netLineAmountColumn: string;
  userCommentColumn: string;
  userCommentPlaceholder: string;
  optionsColumn: string;
  successRemoveItemMessage: string;
  errorRemoveItemMessage: string;
  noItemsMessage: string;
};

export const ITEMS_TABLE: ItemsTableMessages = {
  titleColumn: "Descrição",
  variationColumn: "Variação",
  quantityColumn: "Quantidade",
  mainPriceColumn: "Preço Principal",
  promoPriceColumn: "Preço Promocional",
  startPromoPriceColumn: "Início do Preço Promocional",
  endPromoPriceColumn: "Fim do Preço Promocional",
  skuCodeColumn: "Código (SKU)",
  netUnitPriceColumn: "Valor Unitário",
  netLineAmountColumn: "Total",
  userCommentColumn: "Comentário",
  userCommentPlaceholder: "Adicione um comentário para este produto (obrigatório)",
  optionsColumn: "Opções",

  successRemoveItemMessage: "Item removido com sucesso!",
  errorRemoveItemMessage: "Falha ao remover o item.",
  noItemsMessage: "Nenhum item foi adicionado.",
};
